import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import { App } from './App';
import { loadPlausibleAnalytics } from '@/lib/plausibleLoader';
import { ErrorFallback } from '@/components/shared/ErrorFallback';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (typeof sentryDsn === 'string' && sentryDsn.length > 0) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: `johnicornos@${import.meta.env.VITE_APP_VERSION ?? '0.0.1'}`,
    tracesSampleRate: 0.1,
  });
}

loadPlausibleAnalytics();

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <ErrorFallback error={error instanceof Error ? error : new Error(String(error))} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
